// this file has been generated automatically, do not modify it
import {
  forwardRef,
  type ForwardedRef,
  type HTMLProps,
  type JSX,
  createElement,
} from "react";

import { styled } from "@mobsuccess-devops/styled-system/jsx/factory";

import { ReactComponent as Bold } from "./bold.svg";
import { ReactComponent as Light } from "./light.svg";
import { ReactComponent as Regular } from "./regular.svg";

type ComponentProps = HTMLProps<SVGSVGElement> & {
  variant: "regular" | "light" | "bold";
} & { title?: string };

function Component(
  { variant, children: _children, ...props }: ComponentProps,
  ref: ForwardedRef<SVGSVGElement>,
): JSX.Element | null {
  switch (variant) {
    case "regular":
      return createElement(Regular, { ...props, ref });
    case "light":
      return createElement(Light, { ...props, ref });
    case "bold":
      return createElement(Bold, { ...props, ref });
    default:
      return null;
  }
}

export const IconClose = Object.assign(styled(forwardRef(Component)), {
  variants: ["regular", "light", "bold"],
  Regular: styled(Regular),
  Light: styled(Light),
  Bold: styled(Bold),
});
